import React from 'react'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { Layout, message, Modal, Button, Checkbox } from 'antd'

import { fetchCloudAccounts } from '../../actions/cloud-accounts-actions'
import { play_file } from '../../actions/video-player'
import CloudFlyerAPI from '../../api/CloudFlyerAPI'

import SearchView from './SearchView'
import ResultView from './ResultView'
import FilePreview from './FilePreview'

import PricingModal from '../../components/PricingModal'

import './styles.scss'

let state = null

class Mam extends React.Component {
    constructor(props) {
        super(props)

        const { user } = props

        this.hasAccess =
            user &&
            user.packages &&
            user.packages.map(p => p.title).includes('LiteMAM')

        if (state) {
            this.state = state
        } else {
            this.state = {
                clouds: [],
                buckets: [],

                selected_cloud: {},
                selected_cloud_id: null,
                selected_bucket: null,
                selected_bucket_id: null,

                loading: false,

                results: [],
                view: 'table',
                showPreview: true,
                viewCount: 20,
            }
        }

        this.handleViewChange = this.handleViewChange.bind(this)
        this.handleShowPreview = this.handleShowPreview.bind(this)
        this.handleViewCountChange = this.handleViewCountChange.bind(this)
    }

    componentDidMount() {
        this.props.fetchCloudAccounts()
    }

    componentWillReceiveProps(props) {
        this.setState({ clouds: props.clouds })
    }

    componentDidCatch(e, err) {
        console.log('componentDidCatch', err)
    }

    componentWillUnmount() {
        state = this.state
    }

    handleViewCountChange(newVal) {
        this.setState({ viewCount: newVal })
    }

    handleShowPreview(show) {
        this.setState({ showPreview: show })
    }

    handleViewChange(view) {
        this.setState({ view })
    }

    on_results = results => {
        if (results && results.length) results[0].selected = true
        this.setState({ results: [] }, () => this.setState({ results }))
    }

    on_file_select = (file, single) => {
        if (single)
            for (let i = 0; i < this.state.results.length; i++)
                this.state.results[i].selected = false

        file.selected = !file.selected
        this.setState({ selected_file: file })

        CloudFlyerAPI.mam
            .findProxyFiles({
                keyword: file.name,
                config: {
                    query_type: 'proxy_files_location',
                    bucket_name: file.bucket_name,
                    cloud_account_id: file.cloud_account_id,
                    path: file.path,
                },
            })
            .then(res => {
                file.proxyUrl = ((res || {}).data || {} || {}).download_url
                this.setState({ selected_file: file })
            })
            .catch(() => message.error('Failed to get proxy files'))
    }

    selected_files = () => this.state.results.filter(f => f.selected)

    render() {
        const {
            clouds,
            loading,
            results,
            selected_file,
            view,
            showPreview,
            viewCount,
        } = this.state

        return (
            <div className={'mam-view'}>
                {!this.hasAccess && (
                    <PricingModal
                        productName="LiteMAM"
                        product="search"
                        monthlyPricing={20}
                        annuallyPricing={199}
                        onClose={period => console.log('confirmed : ' + period)}
                    />
                )}
                <SearchView
                    loading={loading}
                    clouds={clouds}
                    onViewChange={this.handleViewChange}
                    view={view}
                    on_results={this.on_results}
                    onViewCountChange={this.handleViewCountChange}
                />

                <br />

                <div className="toggle-file-preview">
                    {showPreview ? (
                        <Button
                            icon="right"
                            onClick={() => this.handleShowPreview(false)}>
                            Hide Preview
                        </Button>
                    ) : (
                        <Button
                            icon="left"
                            onClick={() => this.handleShowPreview(true)}>
                            Show Preview
                        </Button>
                    )}
                </div>

                <div
                    className={
                        showPreview
                            ? 'search-preview file-preview-visible'
                            : 'search-preview file-preview-hidden'
                    }>
                    <ResultView
                        results={results}
                        on_file_select={this.on_file_select}
                        view={view}
                        viewCount={viewCount}
                    />
                    {showPreview && (
                        <FilePreview
                            file={selected_file}
                            selected_files={this.selected_files()}
                        />
                    )}
                </div>
            </div>
        )
    }
}

export default withRouter(
    connect(
        state => ({
            user: ((state || {}).auth || {}).user,
            clouds: ((state || {}).cloudAccounts || []).items || [],
        }),
        dispatch =>
            bindActionCreators(
                {
                    fetchCloudAccounts,
                    play_file,
                    dispatch,
                },
                dispatch
            )
    )(Mam)
)
